import { EntrepriseTLR } from "../../entreprises/entities/entreprise-tlr.entity";

export class TravauxPdpEntity {
    id!: number;
    designation!: string;
    entreprisesConcernees!: EntrepriseTLR[];
    sousTraitantsConcernes!: EntrepriseTLR[];
    entreprisesById!: Map<number, EntrepriseTLR>;
    availableEntreprises!: EntrepriseTLR[];
    entreprisesSelected: Map<number, boolean> = new Map<number, boolean>();
    selectedEntreprises!: { entreprise: EntrepriseTLR }[];
    selectedEntreprise!: any;
    sousTraitantsSelected: Map<number, boolean> = new Map<number, boolean>();
    selectedSousTraitants!: { entreprise: EntrepriseTLR }[];
    selectedSousTraitant!: any;
    coactivite!: string;
    updatable: boolean = true;


    constructor() {
    }
}